var _path, _path2, _path3;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgLinkedin = function SvgLinkedin(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.9996 6.5C15.5909 6.5 17.1171 7.13214 18.2423 8.25736C19.3675 9.38258 19.9996 10.9087 19.9996 12.5V19.5H15.9996V12.5C15.9996 11.9696 15.7889 11.4609 15.4138 11.0858C15.0388 10.7107 14.5301 10.5 13.9996 10.5C13.4692 10.5 12.9605 10.7107 12.5854 11.0858C12.2103 11.4609 11.9996 11.9696 11.9996 12.5V19.5H7.99963V12.5C7.99963 10.9087 8.63178 9.38258 9.75699 8.25736C10.8822 7.13214 12.4083 6.5 13.9996 6.5Z",
    fill: "#D5AC4F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.000366211 7.49854H4.00037V19.4985H0.000366211V7.49854Z",
    fill: "#D5AC4F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.00037 4.5C3.10494 4.5 4.00037 3.60457 4.00037 2.5C4.00037 1.39543 3.10494 0.5 2.00037 0.5C0.895797 0.5 0.000366211 1.39543 0.000366211 2.5C0.000366211 3.60457 0.895797 4.5 2.00037 4.5Z",
    fill: "#D5AC4F"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLinkedin, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/linkedin.91948c6e.svg";
export { ForwardRef as ReactComponent };